export default function gamePage({ to, store, next }) {

    $('html').removeClass('mobile-fixed-screen')
    if (to.matched.some(record => record.meta.gamePage)) {
        $('html').addClass('mobile-fixed-screen')
    }

    if (!get(store.state.auth.preferences, 'animation', false)) {
        $('body').addClass('noanimation')
    } else {
        $('body').removeClass('noanimation')
    }

    return next()
}